import request from '../utils/request'
import requestOpt from '../logic/request-opt.json'

var Http = {};

Http.install = (Vue) => {
  let opt = {
    method: 'post',
    auth: true
  };

  const normalizeMethodOpts = (type, opts, payload, extraOpts = {}) => {
    // 兼容 this.$http.get('/path') 以及 this.$http.post('/path', data) 这类字符串调用
    if (typeof opts === 'string') {
      const payloadKey = type === 'get' ? 'params' : 'data';
      const normalized = Object.assign({
        url: opts,
        method: type
      }, extraOpts);

      if (typeof payload !== 'undefined') {
        normalized[payloadKey] = payload;
      }
      return normalized;
    }

    return Object.assign({}, opts, {
      method: type
    });
  };

  Vue.prototype.$http = (opts) => {
    opts = Object.assign({}, opt, opts);
    return new Promise(function (resolve, reject) {
      request(opts).then(res => {
        if(opts.filter && typeof opts.filter === 'function') {
          // res.data.data => 真正的数据
          if(res.data.data) {
            res.data.data = opts.filter(res.data.data)
          }
        }

        if(res) resolve(res);
      }, res => {
        if(res) reject(res)
      });
    });
  }

  ['get', 'post', 'delete', 'put'].forEach(type => {
    Vue.prototype.$http[type] = (opts, payload, extraOpts) => {
      const normalizedOpts = normalizeMethodOpts(type, opts, payload, extraOpts);
      return Vue.prototype.$http(normalizedOpts);
    }
  });

  Vue.prototype.$http.create = (key, data, extraOpts = {}) => {
    const keyConfig = requestOpt[key];
    if (!keyConfig) {
      return Promise.reject({
        resultDesc: `[http.create] request key not found: ${key}`
      });
    }

    const method = (extraOpts.method || keyConfig.method || 'post').toLowerCase();
    const payloadKey = method === 'get' ? 'params' : 'data';
    const opts = Object.assign({}, keyConfig, extraOpts, {
      method
    });

    if (typeof data !== 'undefined') {
      opts[payloadKey] = data;
    }

    return Vue.prototype.$http(opts);
  }
};

export default  Http;



// WEBPACK FOOTER //
// ./src/plugins/http.js